import { loadPersistedToken } from '@/auth.ts';
import { useEnvironment } from '@/composables/useEnvironment.ts';
import { useServiceWorker } from '@/composables/useServiceWorker.ts';
import PortalVue from 'portal-vue';
import * as Vue from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia'

// Importing all icons so we can register them globally. This is needed for
// the LinkButton component to be able to show those icons.
import Arrow from '@/components/icons/Arrow.vue';
import ArrowLeft from '@/components/icons/ArrowLeft.vue';
import Bell from '@/components/icons/Bell.vue';
import Bolt from '@/components/icons/Bolt.vue';
import Burger from '@/components/icons/Burger.vue';
import Car from '@/components/icons/Car.vue';
import Caret from '@/components/icons/Caret.vue';
import Cart from '@/components/icons/Cart.vue';
import ChargingCable from '@/components/icons/ChargingCable.vue';
import ChartLine from '@/components/icons/ChartLine.vue';
import Check from '@/components/icons/Check.vue';
import CircleEmpty from '@/components/icons/CircleEmpty.vue';
import Clock from '@/components/icons/Clock.vue';
import Cog from '@/components/icons/Cog.vue';
import ConsumptionArrow from '@/components/icons/ConsumptionArrow.vue';
import Copy from '@/components/icons/Copy.vue';
import Edit from '@/components/icons/Edit.vue';
import External from '@/components/icons/External.vue';
import Globe from '@/components/icons/Globe.vue';
import HeartFull from '@/components/icons/HeartFull.vue';
import HeartOutline from '@/components/icons/HeartOutline.vue';
import Home from '@/components/icons/Home.vue';
import List from '@/components/icons/List.vue';
import Lock from '@/components/icons/Lock.vue';
import LockOpen from '@/components/icons/LockOpen.vue';
import Meter from '@/components/icons/Meter.vue';
import Plug from '@/components/icons/Plug.vue';
import Power from '@/components/icons/Power.vue';
import Rotate from '@/components/icons/Rotate.vue';
import SearchMinus from '@/components/icons/SearchMinus.vue';
import SearchPlus from '@/components/icons/SearchPlus.vue';
import SignOut from '@/components/icons/SignOut.vue';
import Sliders from '@/components/icons/Sliders.vue';
import Spinner from '@/components/icons/Spinner.vue';
import Star from '@/components/icons/Star.vue';
import Tag from '@/components/icons/Tag.vue';
import Trash from '@/components/icons/Trash.vue';
import Users from '@/components/icons/Users.vue';
import VerticalEllipsis from '@/components/icons/VerticalEllipsis.vue';
import WhatsApp from '@/components/icons/WhatsApp.vue';

const environment = useEnvironment()
const pinia = createPinia()
const app = Vue.createApp(App)
app.use(router)
app.use(pinia)
app.use(PortalVue)

// Globally registering all icon components.
app.component('ArrowLeft', ArrowLeft)
app.component('Arrow', Arrow)
app.component('Bell', Bell)
app.component('Bolt', Bolt)
app.component('Burger', Burger)
app.component('Caret', Caret)
app.component('Cart', Cart)
app.component('Car', Car)
app.component('ChargingCable', ChargingCable)
app.component('ChartLine', ChartLine)
app.component('Check', Check)
app.component('CircleEmpty', CircleEmpty)
app.component('Clock', Clock)
app.component('Cog', Cog)
app.component('ConsumptionArrow', ConsumptionArrow)
app.component('Copy', Copy)
app.component('Edit', Edit)
app.component('External', External)
app.component('Globe', Globe)
app.component('HeartFull', HeartFull)
app.component('HeartOutline', HeartOutline)
app.component('Home', Home)
app.component('List', List)
app.component('LockOpen', LockOpen)
app.component('Lock', Lock)
app.component('Meter', Meter)
app.component('Plug', Plug)
app.component('Power', Power)
app.component('Rotate', Rotate)
app.component('SearchMinus', SearchMinus)
app.component('SearchPlus', SearchPlus)
app.component('SignOut', SignOut)
app.component('Sliders', Sliders)
app.component('Spinner', Spinner)
app.component('Star', Star)
app.component('Tag', Tag)
app.component('Trash', Trash)
app.component('Users', Users)
app.component('VerticalEllipsis', VerticalEllipsis)
app.component('WhatsApp', WhatsApp)


// Add variables to the window object to allow debugging without browser extensions.
if (!environment.isProduction) {
  window.efApp = app
  window.efPinia = pinia
  window.efRouter = router
}

// update window title
document.title = import.meta.env.VITE_APP_NAME;

// Load the auth tokens very early, so they're available when App is created/mounted.
loadPersistedToken()

app.mount('#app')

const { registerServiceWorker } = useServiceWorker()
registerServiceWorker()